import listSaga from './listSaga'
import listSearchSaga from './listSearchSaga'
import editSaga from './editSaga'
import editItpSaga from './editItpSaga'
import assignedListSaga from './assignedListSaga'
import oneCompanySaga from './oneCompanySaga'
import publishCompanySaga from './publishCompanySaga'
import prePublishCompany from './prePublishCompanySaga'
import advancedListSaga from './advancedListSaga'
import publishedListSaga from './publishedListSaga'
import publishedListSearchSaga from './publishedListSearchSaga'
import statisticsSaga from './statisticsSaga'
import contactCompanySaga from './contactCompanySaga'
import editOneSaga from './editOneSaga'
import contactEditorCompanySaga from './contactEditorCompanySaga'
import contactDeleteCompanySaga from './contactDeleteCompanySaga'
import contactStaticEnumsSaga from './contactStaticEnumsSaga'
import staticEnumsSaga from './staticEnumsSaga'
import contactProfileSaga from './contactProfileSaga'
import itpStaticEnumsSaga from './itpStaticEnumsSaga'
import checkStatusEventSaga from './checkStatusEventSaga'
import onboardingExhibitorSaga from './onboardingExhibitorSaga'
import itpListSaga from './itpListSaga'
import createItpSaga from './createItpSaga'
import deleteItpSaga from './deleteItpSaga'
import getPreSignedUploadURLSaga from './getPreSignedUploadURLSaga'
import uploadImageSaga from './uploadImageSaga'
import createCompanySaga from './createCompanySaga'
import deleteCompanySaga from './deleteSaga'
import shareItpSaga from './shareItp'

const companiesSagas = [
    listSaga(),
    itpListSaga(),
    listSearchSaga(),
    assignedListSaga(),
    oneCompanySaga(),
    editSaga(),
    editItpSaga(),
    publishCompanySaga(),
    prePublishCompany(),
    statisticsSaga(),
    contactCompanySaga(),
    editOneSaga(),
    advancedListSaga(),
    publishedListSaga(),
    publishedListSearchSaga(),
    contactEditorCompanySaga(),
    contactDeleteCompanySaga(),
    contactStaticEnumsSaga(),
    staticEnumsSaga(),
    contactProfileSaga(),
    itpStaticEnumsSaga(),
    checkStatusEventSaga(),
    onboardingExhibitorSaga(),
    createItpSaga(),
    deleteItpSaga(),
    getPreSignedUploadURLSaga(),
    uploadImageSaga(),
    createCompanySaga(),
    deleteCompanySaga(),
    shareItpSaga()
]

export default companiesSagas
